import React, { useMemo } from 'react'
import { MessageStyleType } from 'models/MessageType'
import { palette } from '../../theme/palette'
import { BubbleTailIconSVG } from './BubbleTail.style'

interface Props {
  isFromBot: boolean
  messageStyle: MessageStyleType
  isTypingComponent?: boolean
}

export const BubbleTail: React.FC<Props> = ({ isFromBot, messageStyle, isTypingComponent= false }) => {

  const borderColor = useMemo(() => {
    return isFromBot ? palette.white : messageStyle?.borderColor || palette.sentMessage
  }, [isFromBot, messageStyle?.borderColor])

  const backgroundColor = useMemo(() => {
    return isFromBot ? palette.white : messageStyle?.background || palette.sentMessage
  }, [isFromBot, messageStyle?.borderColor])

  return (
    <BubbleTailIconSVG
      isFromBot={isFromBot}
      isTypingComponent={isTypingComponent}
      aria-hidden="true"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.3 8.6C2.8 7.7 1 3.2 1 0H0C0 1.8 0.5 3.9 1.4 5.6C2.2 7 3.2 8.2 4.7 9H1H0V10H1H6.3C6.3 10 7 10 7 9.3C7 8.6 6.3 8.6 6.3 8.6Z" fill={borderColor}/>
      <path d="M4.7 9H0V0C0 1.8 0.5 3.8 1.4 5.6C2.2 7 3.2 8.2 4.7 9Z" fill={backgroundColor}/>
    </BubbleTailIconSVG>
  )
}
